import * as React from 'react';

import { Pressable, makeUclComponent } from '@rbilabs/universal-components';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, Typography } from 'components/ui';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';
import { useUIContext } from 'state/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

import type { IPressableItemCardProps } from './types';

export const PressableItemCard = makeUclComponent(
  ({
    image,
    altImage = '',
    name,
    price,
    calories,
    icon,
    badge,
    ...props
  }: IPressableItemCardProps) => {
    const { disabled } = props;
    const { formatCurrencyForLocale } = useUIContext();
    const { formatCalories } = useMenuCalories();

    return (
      <Pressable
        flexDirection="row"
        padding="$2"
        justifyContent="space-between"
        backgroundColor={disabled ? primitive.$blackOpacity4 : primitive.$white}
        {...props}
      >
        <Box style={styles.row}>
          <Box style={[styles.image, disabled && styles.disabled]}>
            <Picture w="full" image={image} alt={altImage} />
          </Box>

          <Box style={[styles.details, disabled && styles.disabled]}>
            <Typography variant="headerThree" m="$0">
              {name}
            </Typography>

            <Box style={styles.metadata}>
              {isNumber(price) && (
                <Typography variant="copyTwo">{formatCurrencyForLocale(price)}</Typography>
              )}
              {isString(price) && <Typography variant="copyTwo">{price}</Typography>}
              {isNumber(calories) && (
                <Typography variant="copyTwo" color={getDesignToken('text-disabled')}>
                  {formatCalories(calories)}
                </Typography>
              )}
              {badge ? badge : null}
            </Box>
          </Box>
        </Box>

        <Box style={styles.icon}>{icon}</Box>
      </Pressable>
    );
  }
);

const styles = StyleSheet.create({
  row: { flex: 1, flexDirection: 'row', gap: spacing.$4 },
  image: { justifyContent: 'center', width: spacing.$20 },
  details: { flex: 1, gap: spacing.$1, justifyContent: 'center' },
  metadata: { flexDirection: 'row', gap: spacing.$2 },
  icon: { alignItems: 'flex-end', justifyContent: 'center', marginLeft: spacing.$4 },
  disabled: { opacity: 0.5 },
});
